import { Typography } from "@mui/material";
import React from "react";
import { StoreData } from "../../Objects/StoreInterface";

interface StoreUnitTimeProps {
    storeData: StoreData
    variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "body1" | "body2" | "caption" | "button" | "overline" | "inherit" | undefined
}

const StoreUnitTime: React.FC<StoreUnitTimeProps> = ({
    storeData,
    variant
}) => {
    return (
        <>
            {storeData.str_unit &&
                <Typography
                    variant={variant}
                >
                    {storeData.str_unit.toStgingLength()}
                </Typography>
            }
        </>
    );
}

export default StoreUnitTime